
import React from "react";

const BridgeSection = () => {
  return (
    <section className="section-spacing bg-white" id="bridge">
      <div className="container">
        <div className="text-center max-w-3xl mx-auto mb-12">
          <span className="inline-block text-primary font-medium mb-4 px-3 py-1 bg-primary/10 rounded-full text-sm animate-fade-in">
            Ganzheitlicher Ansatz
          </span>
          <h2 className="animate-fade-in" style={{ animationDelay: '100ms' }}>
            Wanderer zwischen den Welten
          </h2>
          <p className="mt-6 text-joerg-600 animate-fade-in" style={{ animationDelay: '200ms' }}>
            Meine Arbeit mit Privatpersonen und Unternehmen folgt demselben Grundprinzip: Der Mensch steht im Mittelpunkt. Die Methoden und Perspektiven, die ich im Business Consulting einsetze, fließen auch in mein Finanzcoaching ein – und umgekehrt.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          <div className="bg-joerg-50 rounded-2xl p-8 shadow-soft animate-fade-in">
            <h3 className="text-2xl font-semibold text-center">Vom Business zum Privaten</h3>
            <p className="mt-4 text-joerg-600">
              Strategisches Denken und klare Zielsetzungen aus der Unternehmenswelt helfen auch im persönlichen Finanzleben. Ich bringe bewährte Business-Methoden in eine für dich verständliche Form.
            </p>
          </div>

          <div className="bg-joerg-50 rounded-2xl p-8 shadow-soft animate-fade-in" style={{ animationDelay: '200ms' }}>
            <h3 className="text-2xl font-semibold text-center">Vom Privaten zum Business</h3>
            <p className="mt-4 text-joerg-600">
              Empathie und emotionale Intelligenz aus dem Coaching-Bereich fließen in meine Arbeit mit Unternehmen ein. Denn auch im Business geht es letztlich um Menschen, ihre Motivationen und Bedürfnisse.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BridgeSection;
